/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VerdictResult = {
    Pass: 'PASS',
    Fail: 'FAIL'
} as const;
export type VerdictResult = typeof VerdictResult[keyof typeof VerdictResult];

